import { Outlet } from "react-router-dom"
import { NewReportProvider } from "../providers/NewReportProvider"

const ReportFormContainer = () => {
    return (
        <NewReportProvider>
            <Outlet />
        </NewReportProvider>
    )
}

export default ReportFormContainer;